import { Chakra } from "@airhelp/react-ui-components";
import { useLanguage } from "contexts/LocalizationContext";
import { FacebookIcon, InstagramIcon, TwitterIcon, LinkedInIcon } from "styles/icons";
import { getSocialLink } from "utils/socialUtils";

const { Flex, Link } = Chakra;

const QA_ATTRIBUTE = "footer-share-button";

const SocialIcons = () => {
  const language = useLanguage();

  return (
    <Flex mt={{ base: 8, xl: 16 }} data-testid="social-icons">
      <Link
        isExternal
        aria-label="Redirect to facebook"
        href={getSocialLink(language, "facebook")}
        data-testid={QA_ATTRIBUTE}
      >
        <FacebookIcon color="greyscale.500" _hover={{ color: "greyscale.600" }} boxSize="24px" />
      </Link>
      <Link
        isExternal
        aria-label="Redirect to twitter"
        href={getSocialLink(language, "twitter")}
        ml={4}
        data-testid={QA_ATTRIBUTE}
      >
        <TwitterIcon color="greyscale.500" _hover={{ color: "greyscale.600" }} boxSize="24px" />
      </Link>
      <Link
        isExternal
        aria-label="Redirect to instagram"
        href={getSocialLink(language, "instagram")}
        ml={4}
        data-testid={QA_ATTRIBUTE}
      >
        <InstagramIcon color="greyscale.500" _hover={{ color: "greyscale.600" }} boxSize="24px" />
      </Link>
      <Link
        isExternal
        aria-label="Redirect to linkedin"
        href={getSocialLink(language, "linkedin")}
        ml={4}
        data-testid={QA_ATTRIBUTE}
      >
        <LinkedInIcon color="greyscale.500" _hover={{ color: "greyscale.600" }} boxSize="24px" />
      </Link>
    </Flex>
  );
};

export default SocialIcons;
